import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../../../@fury/shared/material-components.module';
import { ScrollbarModule } from '../../../@fury/shared/scrollbar/scrollbar.module';
import { DownloadMobileAppComponent } from './download-mobile-app.component';
import { LoadingOverlayModule } from '../../../@fury/shared/loading-overlay/loading-overlay.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuryAlertBoxModule } from '../../../@fury/shared/alert-box/alert-box.module';
import { LightboxModule } from 'ng-gallery/lightbox';
import { RouterModule } from '@angular/router';
import { FurySharedModule } from '../../../@fury/fury-shared.module';
import { DownloadMobileAppRoutingModule } from './download-mobile-app-routing.module';

@NgModule({
  imports: [
    CommonModule,
    DownloadMobileAppRoutingModule,
    MaterialModule,
    ScrollbarModule,
    LoadingOverlayModule,
    ReactiveFormsModule,
    FuryAlertBoxModule,
    LightboxModule,
    RouterModule,
    FurySharedModule,
    FormsModule,
  ],
  declarations: [DownloadMobileAppComponent],
  exports: [DownloadMobileAppComponent],
  providers: []
})

export class DownloadMobileAppModule {
}
